import { useState } from 'react'

export function useGeneralSettingsState() {
  const [theme, setTheme] = useState('system')
  const [prDestination, setPrDestination] = useState('github')
  const [firstName, setFirstName] = useState('Shiva')
  const [lastName, setLastName] = useState('Chagi')
  const email = 'shivprasadchagi@gmail.com'

  return { theme, setTheme, prDestination, setPrDestination, firstName, setFirstName, lastName, setLastName, email }
}
